// extracted by mini-css-extract-plugin
export default {"pm-info-btn":"Questions_pm-info-btn__EriNx","reason":"Questions_reason__ca5P7"};